import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { TextFieldNew } from '../TextField'
import Icon, { IconName } from '../Icon'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    marginBottom: 12,
  },
  iconContainer: {
    width: 56,
    height: 64,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  iconContainerNormal: {
    background: 'rgba(54, 52, 50, 0.02)',
    border: '1px solid rgba(54, 52, 50, 0.04)',
  },
  iconContainerFilled: {
    background: 'rgba(144, 115, 79, 0.08)',
    border: '1px solid rgba(144, 115, 79, 0.24)',
  },
  textField: {
    flexGrow: 1,
  },
  textInput: {
    height: 64,
    color: 'rgba(54, 52, 50, 0.8)',
    '&::placeholder': {
      color: 'rgba(54, 52, 50, 0.8)',
    },
    '&:focus': {
      color: 'rgba(54, 52, 50, 0.8)',
    },
  },
  textInputFilled: {
    background: 'rgba(203, 166, 122, 0.16)',
    border: '1px solid rgba(203, 166, 122, 0.24)',
    color: '#A78760',
  },
  icon: {
    color: 'rgba(54, 52, 50, 0.56)',
  },
  iconFilled: {
    color: 'rgba(144, 115, 79, 0.8)',
  },
})

interface Props {
  icon: IconName
  label: string
  value: string | null
  onChange: (value: string) => void
  error?: string
}

export const UrlField: FC<Props> = flowMax(
  addDisplayName('UrlField'),
  addProps(({ value }) => ({
    filled: !!value,
  })),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ icon, label, value, onChange, filled, error, classes }) => (
    <div className={classes.container}>
      <div
        className={cx(
          classes.iconContainer,
          filled ? classes.iconContainerFilled : classes.iconContainerNormal
        )}
      >
        <Icon
          name={icon}
          className={cx(filled ? classes.iconFilled : classes.icon)}
        />
      </div>
      <TextFieldNew
        type="url"
        placeholder={label}
        value={value}
        onChange={onChange}
        noMargin
        className={classes.textField}
        inputClassName={cx(
          classes.textInput,
          filled && classes.textInputFilled
        )}
        error={error}
      />
    </div>
  )
)
